import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listTasks(page, pageSize) {
        return axios.get(`tasks?page=${page}&pageSize=${pageSize}`)
    },

    getTaskInfo(taskId) {
        return axios.get(`tasks/${taskId}`)
    },

    getProcessInfo(taskId) {
        return axios.get(`tasks/${taskId}/process-info`)
    },

    getProcesType(taskId) {
        return axios.get(`tasks/${taskId}/process-type`)
    },

    getTaskBits(taskId) {
        return axios.get(`tasks/${taskId}/bits`)
    },

    completeTask(taskId, inputData) {
        return axios.post(`tasks/${taskId}/complete`, inputData)
    },

    getTaskTimeline(taskId) {
        return axios.get(`tasks/${taskId}/timeline`)
    },

    claimActivity(taskId) {
        return axios.post(`tasks/${taskId}/claim`)
    },

    loadSurvey(taskId) {
        return axios.get(`tasks/${taskId}/survey`)
    }
}